module.exports = __webpack_public_path__ + "static/img/product_settings.5fb28776.png";